import React, { useEffect, useState } from "react";
import axios from "axios";
import "./smsForm.css";
import "./smsReport.css";

function SMSReport() {

    const [data, setData] = useState([]);
    const [page, setPage] = useState(0);
    const [size] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [totalCount, setTotalCount] = useState(0);

    // FILTER STATES
    const [status, setStatus] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

    useEffect(() => {
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    const loadData = async () => {
        try {
            const res = await axios.get(
                "https://sms.jaigurujewellers.com/api/v1/smsdata",
                {
                    params: {
                        page,
                        size,
                        status: status || null,
                        mobileNo: mobileNo || null,
                        fromDate: fromDate || null,
                        toDate: toDate || null,
                    }
                }
            );

            setData(res.data.data);
            setTotalPages(res.data.totalPages);
            setTotalCount(res.data.totalCount);

        } catch (err) {
            console.error("Error loading SMS report", err);
        }
    };

    const handleSearch = () => {
        setPage(0);
        loadData();
    };

    const clearFilters = () => {
        setStatus("");
        setMobileNo("");
        setFromDate("");
        setToDate("");
        setPage(0);
        setTimeout(() => loadData(), 100);
    };

    return (
        <div className="page">

            {/* HEADER */}
            <div className="header-card">
                <h2>📊 SMS Report</h2>
                <p>Track sent messages, delivery status, and history</p>
            </div>

            {/* FILTER CARD */}
            <div className="card">
                <div className="filter-box">

                    <select value={status} onChange={(e) => setStatus(e.target.value)}>
                        <option value="">All Status</option>
                        <option value="Y">Success</option>
                        <option value="N">Failed</option>
                    </select>

                    <input
                        type="text"
                        placeholder="Mobile Number"
                        value={mobileNo}
                        onChange={(e) => setMobileNo(e.target.value)}
                    />

                    <input
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                    />

                    <input
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                    />

                    <div className="filter-actions">
                        <button className="button save" onClick={handleSearch}>
                            Search
                        </button>
                        <button className="button clear" onClick={clearFilters}>
                            Clear
                        </button>
                    </div>

                </div>
            </div>

            {/* TABLE CARD */}
            <div className="card">

                <div className="report-summary">
                    <span>Total Records: <b>{totalCount}</b></span>
                    <span>Page <b>{page + 1}</b> of {totalPages || 1}</span>
                </div>

                <div className="table-wrapper">
                    <table className="report-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Mobile</th>
                                <th>Message</th>
                                <th>Status</th>
                                <th>Batch</th>
                                <th>Date</th>
                            </tr>
                        </thead>

                        <tbody>
                            {data.map((item) => (
                                <tr key={item.serno}>
                                    <td>{item.serno}</td>
                                    <td>{item.mobileno}</td>
                                    <td className="msg-cell">{item.messages}</td>
                                    <td>
                                        <span className={item.status === "Y" ? "badge active" : "badge inactive"}>
                                            {item.status === "Y" ? "Success" : "Failed"}
                                        </span>
                                    </td>
                                    <td>{item.batchNo}</td>
                                    <td>{item.updated}</td>
                                </tr>
                            ))}

                            {data.length === 0 && (
                                <tr>
                                    <td colSpan={6} className="no-data">No records found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* PAGINATION */}
                <div className="pagination">
                    <button
                        className="page-btn"
                        disabled={page === 0}
                        onClick={() => setPage(page - 1)}
                    >
                        ⬅ Prev
                    </button>

                    <span className="page-info">Page {page + 1}</span>

                    <button
                        className="page-btn"
                        disabled={page >= totalPages - 1}
                        onClick={() => setPage(page + 1)}
                    >
                        Next ➡
                    </button>
                </div>

            </div>
        </div>
    );
}

export default SMSReport;